import Codes from './components/Codes';
export default Codes;